import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMentorshipProgramSurveyByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  objects?: Types.InputMaybe<Types.MentorshipSurvey_Set_Input>;
}>;


export type UpdateMentorshipProgramSurveyByIdMutation = { __typename?: 'mutation_root', update_mentorshipSurvey_by_pk?: { __typename?: 'mentorshipSurvey', id: number, preSurveyEnabled: boolean, preSurveyLink?: string | null, preSurveyMentorRequired?: boolean | null, preSurveyMenteeRequired?: boolean | null, midSurveyEnabled: boolean, midSurveyLink?: string | null, midSurveyMentorRequired?: boolean | null, midSurveyMenteeRequired?: boolean | null, postSurveyEnabled: boolean, postSurveyLink?: string | null, postSurveyMentorRequired?: boolean | null, postSurveyMenteeRequired?: boolean | null } | null };


export const UpdateMentorshipProgramSurveyByIdDocument = gql`
    mutation updateMentorshipProgramSurveyById($id: Int!, $objects: mentorshipSurvey_set_input) {
  update_mentorshipSurvey_by_pk(pk_columns: {id: $id}, _set: $objects) {
    id
    preSurveyEnabled
    preSurveyLink
    preSurveyMentorRequired
    preSurveyMenteeRequired
    midSurveyEnabled
    midSurveyLink
    midSurveyMentorRequired
    midSurveyMenteeRequired
    postSurveyEnabled
    postSurveyLink
    postSurveyMentorRequired
    postSurveyMenteeRequired
  }
}
    `;
export type UpdateMentorshipProgramSurveyByIdMutationFn = Apollo.MutationFunction<UpdateMentorshipProgramSurveyByIdMutation, UpdateMentorshipProgramSurveyByIdMutationVariables>;

/**
 * __useUpdateMentorshipProgramSurveyByIdMutation__
 *
 * To run a mutation, you first call `useUpdateMentorshipProgramSurveyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorshipProgramSurveyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorshipProgramSurveyByIdMutation, { data, loading, error }] = useUpdateMentorshipProgramSurveyByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateMentorshipProgramSurveyByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMentorshipProgramSurveyByIdMutation, UpdateMentorshipProgramSurveyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMentorshipProgramSurveyByIdMutation, UpdateMentorshipProgramSurveyByIdMutationVariables>(UpdateMentorshipProgramSurveyByIdDocument, options);
      }
export type UpdateMentorshipProgramSurveyByIdMutationHookResult = ReturnType<typeof useUpdateMentorshipProgramSurveyByIdMutation>;
export type UpdateMentorshipProgramSurveyByIdMutationResult = Apollo.MutationResult<UpdateMentorshipProgramSurveyByIdMutation>;
export type UpdateMentorshipProgramSurveyByIdMutationOptions = Apollo.BaseMutationOptions<UpdateMentorshipProgramSurveyByIdMutation, UpdateMentorshipProgramSurveyByIdMutationVariables>;